import React from 'react';
import _ from 'lodash';
import { generatePath } from 'react-router';
import API, { AxiosRequestConfig } from 'axios';

export const getErrorMessage = (error: any): any => {
	let message;
	if (error.response) {
		if (error.response.data.message) {
			message = `${error.response.data.message}${error.response.data.requestId ? `\nError Code: ${error.response.data.requestId}` : ''}`;
		} else if (error.response.data.errors && _.size(error.response.data.errors) > 0) {
			message = _.map(error.response.data.errors, (error, key) => (
				<div key={key}>{error}</div>
			));
		} else if (error.response.statusText) {
			message = error.response.statusText;
		}
	} else if (error.errors) {
		message = _.map(error.errors , (error, key) => (
			<div key={key}>{error}</div>
		));
	} else {
		message = error.message ? error.message : error;
	}

	return message;
};

export const routeTo = (path: string, newTab?: boolean) => {
	if (newTab) {
		window.open(path, '_blank', 'noopener noreferrer');
	} else {
		window.location.pathname = path;
	}
};

// This is used to check whether a user has a specific permission on the "Role" type
// export const hasPermission = (permissions: Role[] | undefined, permission: Role): boolean => {
//   if (permissions !== undefined) {
//     return _.findIndex(permissions, i => (i === permission)) !== -1
//   }

//   return false
// }

export const isNullOrUndefined = (value): any => {
	return value === undefined || value === null;
};

export const ifNullOrUndefined = (value, elseValue): ifNullOrUndefinedParams => {
	return value === undefined || value === null ? elseValue : value;
};

export const stringIsNullOrUndefinedOrBlank = (value): boolean => {
	return isNullOrUndefined(value) || value.trim() === '';
};

interface ifNullOrUndefinedParams {
	value: any;
	elseValue: any;
}

export const isNull = (value): boolean => {
	if (value === '' || value === undefined || value === null || isNaN(value)) {
		return true;
	}
	return false;
};

export const formatBytes = (numBytes: number) => {
	const numKilobytes = numBytes / 1024;
	if (numKilobytes < 1)
		return `${numBytes} bytes`;

	const numMegabytes = numKilobytes / 1024;
	if (numMegabytes < 1)
		return `${Math.round(numKilobytes * 10) / 10} KB`;

	const numGigabytes = numMegabytes / 1024;
	if (numGigabytes < 1)
		return `${Math.round(numMegabytes * 10) / 10} MB`;

	return `${Math.round(numGigabytes * 10) / 10} GB`;
};

export const getFileName = headers => {
	const fileRe = /filename=(.*);/;
	const fileNameHeader = headers['content-disposition'];

	const match = fileRe.exec(fileNameHeader);
	if (match && match[1]) {
		return match[1];
	}

	return null;
};

export const getCookie = name => {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);

	if (_.size(parts) > 0) {
		return parts.pop()?.split(';').shift();
	}
};

export const getDocHeight = (): number => Math.max(
	document.body.scrollHeight, document.documentElement.scrollHeight,
	document.body.offsetHeight, document.documentElement.offsetHeight,
	document.body.clientHeight, document.documentElement.clientHeight
);

export const stringIsNumber = str => {
	return !stringIsNullOrUndefinedOrBlank(str) && !isNaN(+str);
};

export const generatePathForceParams = (path: string, params: any) => {
	let finalPath = path;
	const paramKeys: string[] = [];

	_.forOwn(params, (value, key) => {
		if (!new RegExp(`.*/\\:${key}\\??.*`).test(finalPath))
			finalPath += `/:${key}`;
	});

	return generatePath(finalPath, params);
};

export const removeElementFromArray = (array: any[], index: number) => {
	return array?.slice(0, index).concat(array.slice(index + 1)) || [];
};

export const divideArray = (array: any[] | null | undefined, maxLength) => {
	if (isNullOrUndefined(array))
		return array;

	const res = array?.reduce((acc, curr, i) => {
		if (!(i % maxLength)) {    // if index is 0 or can be divided by the `size`...
			acc.push(array?.slice(i, i + maxLength));   // ..push a chunk of the original array to the accumulator
		}
		return acc;
	}, []);

	return res;
};

export const downloadFile = (url: string, fileName: string) => {
	const config: AxiosRequestConfig = {
		responseType: 'blob'
	};

	API.get(url, config)
		.then(data => {
			const url = window.URL.createObjectURL(new Blob([data.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
			window.URL.revokeObjectURL(link.href);
			document.body.removeChild(link);
		})
		.catch(error => console.error(error));
};